import create from 'zustand'
import { IolType } from '../../types/graphql'

type IolTypeFormValues = {
  data: IolType
  isEditing: boolean
}

type IolTypeFormActions = {
  setData: (data: IolType) => void
  reset: () => void
  setIsEditing: (isEditing: boolean) => void
}

export type IolTypeFormState = IolTypeFormValues & IolTypeFormActions

const initialState: IolTypeFormValues = {
  isEditing: false,
  data: {
    id: '',
    internalAnnotations: '',
    position: 0,
    name: '',
    slug: '',
    enable: true,
    thumb: '',
    timestamp: {},
    cacheKey: ''
  }
}

export const useIolTypeForm = create<IolTypeFormState>(set => ({
  ...initialState,
  setData: data => set(state => ({ ...state, data })),
  reset: () => set({ ...initialState }),
  setIsEditing: isEditing => set(state => ({ ...state, isEditing }))
}))
